
import { Vue, Prop, Component } from 'vue-property-decorator';

@Component<InfoBanner>({})

export default class InfoBanner extends Vue {
	@Prop({ type: String, required: true, default: '' }) private message!: string;
	@Prop({ type: String, required: false, default: '' }) private color!: string;
	@Prop({ type: String, required: false, default: 'information-outline' }) private iconName!: string;

	/**
	 * Handle clicks on a specific text within the banner message
	 *
	 * @param {Event} event
	 * @return {void}
	 */
	private clickOnLink(event: Event): void {
		const target = event.target as HTMLElement;
		if (target?.classList.contains('link')) {
			this.$emit('link-click');
		}
	}
}
